import React from 'react'
import classnames from 'classnames'
import { AnchorLink, Dropdown, Lazyload, BackToTop, Video, Bet365 } from '../../common'
import { getBallClass } from '../../../lib/utils/common'
import { Scorers } from './index'
import { bet365AffiliateCodes } from '../../../constants/bet365AffiliateCodes'


var Entities = require('html-entities').XmlEntities

const entities = new Entities()

const EndOfOver = ({
  details = '',
  batsmen = [],
  bowlers = [],
  bet365 = {},
  endOfOverRunsReq = '',
  isLimitedOvers,
  editionDomain = ''
}) => {
  const affiliateCode = editionDomain === 'www.espncricinfo.com' ? bet365AffiliateCodes.endOfOver : bet365AffiliateCodes.editions

  return(
    <div className="commentary-item end-of-over">
      <h4>END OF OVER:<div>
        {details + ' '}
        {isLimitedOvers ? endOfOverRunsReq : null }
      </div></h4>{/*endOfOverRunsReq only for limited over matches*/}

      <ul className="two-col-table">
      {
        batsmen.map((player = {}, i) => {
          return <li key={i} dangerouslySetInnerHTML={{ __html: `${player.name}<span>${player.stat}</span>` }}></li>
        })
      }
      </ul>
      <ul className="two-col-table">
      {
        bowlers.map((player = {}, i) => {
          return <li key={i} dangerouslySetInnerHTML={{ __html: `${player.name}<span>${player.stat}</span>` }}></li>
        })
      }
      </ul>
      { bet365.showInEdition && bet365.showInGeo &&
        <div className="bet">
          <Bet365 {...bet365} type="odds" affiliateCodeOverwrite={affiliateCode}  />
        </div>
      }
    </div>
  )
}

const CommentaryItem = ({
  text = '',
  timeStamp = '',
  pre = '',
  post = '',
  video = {},
  event,
  hasVideoId = false,
  videoId = '',
  isWebView,
  commId = '',
  commSeq = '',
  dismissalText = ''
}) => {

  let eventClassName = getBallClass(event)

  //console.info('isPartCommentary', isPartCommentary)

  let topComms = post
  let bottomComms = pre
  let commDefaultText = entities.decode(text.replace(/\n/gm, '<br/>'))

  /*
  let videoStyles = {
    position: 'absolute',
    margin: 'auto 0'
  }
  */
  //console.info('video in jsx', video)
  return (
    <div className={`commentary-item ${pre || post ? 'pre' : '' } ${hasVideoId ? 'commentary-item--hasVideo' : '' }`}>
        { topComms &&
          entities.decode(topComms).split('\n\n').map((text, i) => {
            let tKey = 't' + commSeq + commId + i
            //console.info('topCommsID', tKey)
            return (
              <p className="comment" key={tKey} dangerouslySetInnerHTML={{ __html: text }} />
            )
          }) || null
        }
        { timeStamp &&
          (<div className="item-wrapper">
              <div className="over">
                  <div className="time-stamp">{timeStamp}</div>
                  <div className={classnames(eventClassName)}><span className="over-score">{event}</span></div>
              </div>
              <div className="description" dangerouslySetInnerHTML={{ __html: commDefaultText }} />
              {
                hasVideoId &&
                (<div key={videoId} className="highlight active">
                  <a data-linktype="lecvideo" className={classnames('highlight icon-font-after icon-play-solid-after gamepackage_bloom module_bloom_behavior', { 'app_partial' : isWebView } )} data-behavior="module_bloom" data-id={videoId}>
                    <Video {...video} showCaption={true} className=""/>
                  </a>
                </div>) || null
              }
          </div>) || null
        }
        {
          dismissalText.length &&
          (<p className = "dismissal" dangerouslySetInnerHTML = {{ __html: dismissalText }} />) || null
        }
        { bottomComms &&
          entities.decode(bottomComms).split('\n\n').map((text, i) => {
            let bKey = 'b' + commSeq + commId + i
            //console.info('bottomCommsID', bKey)
            return (
              <p className="comment" key={bKey} dangerouslySetInnerHTML={{ __html: text }} />
            )
          }) || null
        }
    </div>
  )
}

/**
 * React Commentary element
 * @return {React.PropTypes.element} Commentary
 */
const Commentary = ({
  scorer = '',
  commentator = '',
  showFooter = false,
  href = '',
  overs = [],
  allInnings = [],
  selInnings = '',
  showFilters = false,
  cmtryFilter,
  selFilter,
  page = null,
  hasMore = true,
  updateMoreCommentary,
  isPartCommentary = false,
  commentPreText = '',
  trackingName = '',
  //platform = '',
  isWebView = false,
  routerPush,
  bet365 = {},
  isLimitedOvers,
  isSmallDevice,
  gameState = '',
  editionDomain = ''
}) => {

  const commentary = (
    <article className={classnames('sub-module match-commentary cricket', { 'add-padding' : !isPartCommentary })}>
      {
        showFilters && allInnings.length &&        
        <header className="bordered">
            <div className="filters">
              <Dropdown items={allInnings} selected={selInnings.name} routerPush={routerPush}/>
              {
                cmtryFilter &&
                <Dropdown items={cmtryFilter} selected={selFilter} routerPush={routerPush}/>
              }
            </div> 
        </header> || null
      }
        <div className="content">
          { 
            //this should appear only on mobile and when match is not final 
            (scorer || commentator) && gameState !== 'final' && isSmallDevice && <Scorers scorer={scorer} commentator={commentator} /> || null
          }
          {//this should appear in all breakpoints when match is in Final
            (scorer || commentator) && gameState === 'final' && <Scorers scorer={scorer} commentator={commentator} /> || null
          }
          {
            overs.map((o, i) => {
              let eodProps = {
                details: o.endOfOver,
                batsmen: o.batsmen,
                bowlers: o.bowlers,
                endOfOverRunsReq: o.endOfOverRunsReq,
                isLimitedOvers: isLimitedOvers,
                editionDomain: editionDomain
              }

              if(o.endOfOver && o.hasLastEndOfOver && (selInnings.isCurrent || isPartCommentary)) {
                eodProps.bet365 = bet365
              }
              const comms = (o.comments || []).map((c) => {
                return <CommentaryItem key={c.commSeq} timeStamp={c.timeStamp} commId={c.commId} commSeq={c.commSeq} {...c} index={i} isWebView={isWebView}/>
              })
              let overSummary = [
                o.endOfOver && <EndOfOver key={i} {...eodProps} /> || null,
                comms
              ]
              return overSummary
            })
          }
          { updateMoreCommentary &&
            <Lazyload page={page} threshold={0.3} hasMore={hasMore} updateMore={updateMoreCommentary} enableLoader={true} enableForceLazyload={true} increment={-1} />
          }

        </div>
        { (page > 1) &&
          <BackToTop />
        }
        {
          showFooter && href &&
          <footer>
            <AnchorLink name={trackingName} to={href} text="Full Commentary"/>
          </footer>
        }
    </article>
  )

  return overs.length || (overs.length === 0 && commentPreText) ? commentary : <article className="sub-module match-commentary cricket" />
}

export default Commentary



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/Commentary.jsx
 **/